// ═══════════════════════════════════════════════════════════════════════
// WhatThisOSIsSolving.tsx — Phase 3 personalization card
// ═══════════════════════════════════════════════════════════════════════
// Renders the Agentic Operating System's mission + up to 3 pain points at the top of the
// dashboard screen so the user sees their own situation reflected back —
// not a generic "Welcome to your Agentic Operating System" surface. Data is sourced from
// /api/charter/check/:osId (mission + domain_context.pain_points).
//
// Renders nothing when both mission and pain_points are empty (legacy
// or thin-charter Operating Systems (Applications) degrade silently).
// ═══════════════════════════════════════════════════════════════════════

interface WhatThisOSIsSolvingProps {
  mission?: string;
  painPoints?: string[];
}

export function WhatThisOSIsSolving({ mission, painPoints }: WhatThisOSIsSolvingProps) {
  const trimmedMission = (mission || "").trim();
  const pains = Array.isArray(painPoints)
    ? painPoints.filter((p) => typeof p === "string" && p.trim().length > 0).slice(0, 3)
    : [];

  if (!trimmedMission && pains.length === 0) return null;

  return (
    <section className="rounded-2xl border border-zinc-200 bg-white p-6">
      <h2 className="text-[11px] font-semibold uppercase tracking-wider text-zinc-500 mb-3">
        What the Agentic Operating System is solving for you
      </h2>
      {trimmedMission && (
        <p className="text-base italic text-zinc-700 leading-relaxed mb-4">
          {trimmedMission}
        </p>
      )}
      {pains.length > 0 && (
        <ul className="space-y-2">
          {pains.map((p, i) => (
            <li key={i} className="flex items-start gap-2 text-sm text-zinc-800 leading-relaxed">
              <span className="mt-[7px] w-1.5 h-1.5 rounded-full bg-zinc-400 flex-shrink-0" />
              <span>{p}</span>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
